import { Component, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { HttpHelpService } from "../service/http-help.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AddCompanyEndPoient, AddCompanyPermissionsEndPoient } from "../service/global.service";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import Swal from 'sweetalert2';
import { of, catchError, forkJoin } from "rxjs";
import { map, skip } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { InvoiceSubscriptionsV2Service } from "../../services/invoice-subscriptions-v2.service";
import { ActivatedRoute, Router } from "@angular/router";
import { getDefaultReportLanguage } from "src/app/shared/services/report-language-preference";
@Component({
  selector: "app-company",
  templateUrl: "./company.component.html",
  styleUrls: ["./company.component.scss"]
})

export class CompanyComponent implements OnInit {
  /** sessionStorage key — restored on browser back when history lacks ?tab=archived */
  static readonly COMPANIES_TAB_STORAGE_KEY = 'fawtara.companiesListTab';

  @Input() isInsideModal: boolean = false;

  readonly today = new Date();
  curentLang:string="";
  layoutVersion:any;
  userRegistId:any = JSON.parse(localStorage.getItem('user_id'));
  merchantId = JSON.parse(localStorage.getItem('merchant_id'));
  user_type = JSON.parse(localStorage.getItem('user_type'));
  selectedOffice:any;

  term:any;
  p: any;
  companyData:any=[];
  addCompany:FormGroup;
  addCompanyByAdmin:FormGroup;
  addPermissionForm:FormGroup;

  merchantInfoData:any=[];
  merchantInfoCompanyData:any=[];
  vatInfoData:any=[];
  companyTypeData:any=[];
  currentPage: number = 1;
  limit: number = 400;
  customLimit: number = 400;
  offset: number = 0;
  total: number = 0; 
  activeAccountantOfficeData:any=[];
  CompanyId:any;
  MerchantID:any;
  redirectUrl:any;
  public validate = false;
  public addvalidateCompanyMerchant = false;
  canAddCompanyAllowed: boolean = true;
  CompanyIdRow:any;
  archiveCompanyId: any;
  restoreCompanyId: any;
  archivedCompanyData: any[] = [];
  showArchivedSection = false;
  archivedCount = 0;
  activeTab: 'active' | 'archived' = 'active';
  /** Admin only: merchant vs accountant company records (never use 'all' on default screen). */
  adminRecordType: 'merchant' | 'accountant' = 'merchant';
  allCompaniesForReport: any[] = [];
  /** company_id → link badge after accountant approval (merchant only). */
  companyLinkStatusByCompanyId: Record<number, 'linked' | 'not_linked'> = {};
  private approvedCompanyIds = new Set<number>();
  private readonly agreedPermissionStatus = 17;

  /** Add-company modal: optional translation blocks (matches prototype “add language”). */
  translationAddon: { ar: boolean; en: boolean } = { ar: false, en: false };
  translationPickerOpen = false;

  moreInfoData: any = null;
  moreInfoCompanyName = '';
  moreInfoLoading = false;
  moreInfoLoadFailed = false;
  private moreInfoRequest = 0;

  pendingLogoFile: File | null = null;
  pendingSealFile: File | null = null;
  logoPreviewUrl: string | null = null;
  sealPreviewUrl: string | null = null;
  documentForm: FormGroup ;
  selectedPeriod: number = 1;
  fromDate: string | null = null;
  toDate: string | null = null;
  ReportDataFilters: any = [];
  reportsForm: FormGroup ;
  private entryNavigationTrigger = 'imperative';

  constructor(
    private spinner: NgxSpinnerService ,
    public translate:TranslateService ,
    private service:HttpHelpService  ,
    private modalService: NgbModal,
    private toastr: ToastrService ,
    private fb: FormBuilder,
    private invoiceSubscriptionsV2: InvoiceSubscriptionsV2Service,
    private router: Router,
    private route: ActivatedRoute,
  ) 
  { 
    const nav = this.router.getCurrentNavigation();
    this.entryNavigationTrigger = nav?.trigger ?? 'imperative';

    this.curentLang = localStorage.getItem('curentLang');
    this.merchantId = JSON.parse(localStorage.getItem('merchant_id'));

   this.addCompany=new FormGroup({
      company_name_ar :new FormControl(''),
      company_name_en:new FormControl(''),
      company_phone:new FormControl(''),
      company_name_he :new FormControl('' , Validators.required),  
      tax_register :new FormControl('' , Validators.required ),  
      commercial_register :new FormControl('' , Validators.required ),  
      company_address_str :new FormControl('' ,Validators.required  ),
    company_address_str_ar :new FormControl(''),
    company_address_str_en :new FormControl(''),
      company_Building_number :new FormControl('' , Validators.required),
      company_address_city :new FormControl('' , Validators.required ),
    company_address_city_ar :new FormControl(''),
    company_address_city_en :new FormControl(''),
      company_address_zip_code :new FormControl(''),
      left_note: new FormControl('', [Validators.maxLength(200)]),
      right_note: new FormControl('', [Validators.maxLength(200)]),
      merchant_id :new FormControl(this.merchantId ),  
      vat_list_id :new FormControl(''),
      company_type_id :new FormControl('', Validators.required),
      created_by:new FormControl(this.userRegistId),
    });

    this.addCompanyByAdmin=new FormGroup({
      company_name_ar :new FormControl(''),
      company_name_en:new FormControl(''),
      company_name_he :new FormControl('' , Validators.required),  
      company_phone:new FormControl(''),
      tax_register :new FormControl('' , Validators.required ),  
      commercial_register :new FormControl('' , Validators.required ),  
      company_address_str :new FormControl('' ,Validators.required ),
      company_address_str_ar :new FormControl(''),
      company_address_str_en :new FormControl(''),
      company_Building_number :new FormControl('' , Validators.required),
      company_address_city :new FormControl('' , Validators.required ),
      company_address_city_ar :new FormControl(''),
      company_address_city_en :new FormControl(''),
      company_address_zip_code :new FormControl(''),
      left_note: new FormControl('', [Validators.maxLength(200)]),
      right_note: new FormControl('', [Validators.maxLength(200)]),
      merchant_id :new FormControl('' , Validators.required),  
      vat_list_id :new FormControl(''),
      company_type_id :new FormControl('', Validators.required),
      created_by:new FormControl(this.userRegistId),
    });


    this.addPermissionForm = new FormGroup({
      companyUser: new FormControl([], Validators.required),   
      office_id: new FormControl(),
      merchant_id: new FormControl(),
      created_by: new FormControl(this.userRegistId),
    });


    this.reportsForm = new FormGroup({
      companyId: new FormControl(this.CompanyId),
      startDate: new FormControl('', Validators.required),
      endDate: new FormControl('', Validators.required),
      lang  : new FormControl(getDefaultReportLanguage()),
    });

    
   
  
  };
  isNumber(event: KeyboardEvent) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    } else {
      return true;
    }
  }
   
  addedPermission() {
    if (this.addPermissionForm.invalid) {
      Swal.fire({
        icon: 'warning',
        title: this.curentLang === 'ar' ? 'يرجى ملء جميع الحقول' : (this.curentLang === 'en' ? 'Please fill all fields' : (this.curentLang === 'he' ? 'בבקשה תמלא את כל השדות' : ''))
      });
      return;
    } else {
      const companyUsers = this.addPermissionForm.value.companyUser;
      
      const models = companyUsers?.map(companyUser => ({
        office_id: Number(companyUser.office_id),
        company_id: Number(this.CompanyId), // تأكد من أنك تحصل على معرف المصلحة التجارية بشكل صحيح
        merchant_id: Number(this.MerchantID),
        created_by: Number(this.userRegistId),
      }));

       
    
      this.spinner.show();
      this.service.Post(AddCompanyPermissionsEndPoient.POST, models).subscribe((res) => {
        this.spinner.hide();
        if (res.status === 200) {
          Swal.fire({
            icon: 'success',
            title: this.curentLang === 'ar' ? res.messageAr : (this.curentLang === 'en' ? res.messageEn : res.messageHe)
          });
          this.modalService.dismissAll();
          this.getAllActiveAccountingOffices();
          this.getAllCompaniesInfo();
          this.getAllMerchantInfo();
          this.loadCompanyLinkStatuses();
          this.addPermissionForm.reset();
        } else {
          let errorMessage = this.curentLang === 'ar' ? res.messageAr : (this.curentLang === 'en' ? res.messageEn : res.messageHe);
          Swal.fire({
            icon: 'error',
            title: errorMessage
          });
        }
      });
    }
  };

  filterSelected(event: any) {
    this.selectedOffice = event;
    this.addPermissionForm.patchValue({ office_id: this.selectedOffice });
  };

  getIdToSend(id:number)
  {
    this.CompanyId = id;
    this.reportsForm.patchValue({
      companyId: id
    });
  };
  openVerticallyCenteredConfirmed(content4: any) {
    this.modalService.open(content4, { centered: true });
  };

  openXl4(content4:any) {
    this.modalService.open(content4, { size: 'md' , centered:true });
  };

  ConnectWithTaxGovernment() {
    this.spinner.show();
  
    const connectFunc = this.service.ConnectWithTaxGovernment.bind(this.service);
  
    connectFunc(this.CompanyId).subscribe((res) => {
      if (res && res.url) {
        const redirectUrl = res.url;
  
        // Show toast
        const Toast = Swal.mixin({
          toast: true,
          position: 'top',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          color: 'green',
          backdrop: true,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
          }
        });
  
        Toast.fire({
          icon: 'success',
          title: this.curentLang === 'ar' ? 'برجاء الأنتظار سيتم تحويلك الأن الي موقع مصلحة الضرائب' : 
                 (this.curentLang === 'en' ? 'Please wait. You will now be transferred to the Tax Authority website' : 
                 'אנא המתן כעת תועבר לאתר רשות המסים')
        });
  
        this.modalService.dismissAll();
  
        // Open redirect URL in the same tab
        window.location.href = redirectUrl;
      } else {
        this.toastr.error('No redirect URL found');
      }
      this.spinner.hide();
    }, (error) => {
      this.toastr.error('An error occurred');
      this.spinner.hide();
    });
  }
  
  
  isTokenExpired(expirationDate: string): boolean {
    const expiration = new Date(expirationDate);
    const now = new Date();
    return now >= expiration;
  }
  handleClick(companyId: number, content4: any) {
      this.getIdToSend(companyId);
     
  };

  // handleClick(companyId: number, content4: any, expirationDate: string) {
  //   if (this.isTokenExpired(expirationDate)) {
  //     this.getIdToSend(companyId);
  //     this.openXl4(content4);
  //   }
  // }
  
  getCompanyId(id:number , merchantid:number)
  {
     this.CompanyId = id ;
     this.MerchantID = merchantid

  };

  
  changeShowSignatureCompany(company_id: any, showSignature: any) {
    this.spinner.show();

    // عكس قيمة showSignature
    showSignature = showSignature == true ? false : true;

    // استدعاء الخدمة مع المعاملات
    this.service.changeShowSignatureCompany(company_id, showSignature).subscribe({
        next: res => {
            Swal.fire({
                icon: 'success',
                title: this.curentLang === 'ar' ? res.messageAr : (this.curentLang === 'en' ? res.messageEn : res.messageHe),
            });

            this.getAllCompaniesInfo(); // تحديث بيانات المصالح التجارية
            this.spinner.hide();
        },
        error: err => {
            Swal.fire({
                icon: "error",
                title: err.error.message
            });
            this.spinner.hide();
        }
    });
};


changeShowSealCompany(company_id: any, showSeal: any) {
  this.spinner.show();

  // عكس قيمة showSignature
  showSeal = showSeal == true ? false : true;

  // استدعاء الخدمة مع المعاملات
  this.service.changeShowSealCompany(company_id, showSeal).subscribe({
      next: res => {
          Swal.fire({
              icon: 'success',
              title: this.curentLang === 'ar' ? res.messageAr : (this.curentLang === 'en' ? res.messageEn : res.messageHe),
          });

          this.getAllCompaniesInfo(); // تحديث بيانات المصالح التجارية
          this.spinner.hide();
      },
      error: err => {
          Swal.fire({
              icon: "error",
              title: err.error.message
          });
          this.spinner.hide();
      }
  });
};

  /**
   * Company list: show Hebrew name if set, else English, else Arabic (API may return empty strings).
   */
  getCompanyDisplayName(row: any): string {
    if (!row) return '';
    const he = (row.company_name_he ?? '').toString().trim();
    if (he) return he;
    const en = (row.company_name_en ?? '').toString().trim();
    if (en) return en;
    return (row.company_name_ar ?? '').toString().trim();
  }

  getCompanyDisplayNameInitial(row: any): string {
    const n = this.getCompanyDisplayName(row);
    return n ? n.charAt(0).toUpperCase() : '';
  }

  companyTypeLabel(row: any): string {
    const nested = row?.companyType || row?.company_type;
    const fromRow = this.localizedCompanyTypeName(nested);
    if (fromRow) return fromRow;
    const id = Number(row?.company_type_id);
    const match = (this.companyTypeData || []).find((type: any) => Number(type?.company_type_id) === id);
    return this.localizedCompanyTypeName(match) || '—';
  }

  private localizedCompanyTypeName(type: any): string {
    if (!type) return '';
    const ar = String(type.type_name_ar ?? '').trim();
    const en = String(type.type_name_en ?? '').trim();
    const he = String(type.type_name_he ?? '').trim();
    if (this.curentLang === 'en') return en || ar || he;
    if (this.curentLang === 'he') return he || en || ar;
    return ar || en || he;
  }

  private isMerchantUser(): boolean {
    const ut = Number(this.user_type);
    return ut === 100 || ut === 101;
  }

  isAdminUser(): boolean {
    const ut = Number(this.user_type);
    return ut === 200 || ut === 201;
  }

  private getRecordTypeForList(): 'merchant' | 'accountant' {
    return this.isAdminUser() ? this.adminRecordType : 'merchant';
  }

  switchAdminRecordType(type: 'merchant' | 'accountant'): void {
    if (this.adminRecordType === type) {
      return;
    }
    this.adminRecordType = type;
    this.currentPage = 1;
    this.activeTab = 'active';
    this.syncTabToUrl('active');
    this.getAllCompaniesInfo();
  }

  shouldShowArchivedTab(): boolean {
    return !this.isAdminUser() || this.adminRecordType === 'merchant';
  }

  shouldShowCompanyLinkBadge(companyId: number): boolean {
    return this.isMerchantUser() && this.approvedCompanyIds.has(Number(companyId));
  }

  getCompanyLinkBadgeLabel(companyId: number): string {
    const linked = this.companyLinkStatusByCompanyId[Number(companyId)] === 'linked';
    if (linked) {
      return this.curentLang === 'ar'
        ? 'مرتبطة بمحاسب'
        : (this.curentLang === 'en' ? 'Linked to accountant' : 'מקושרת לרואה חשבון');
    }
    return this.curentLang === 'ar'
      ? 'غير مربوطة'
      : (this.curentLang === 'en' ? 'Not linked' : 'לא מקושרת');
  }

  getCompanyLinkBadgeClass(companyId: number): string {
    return this.companyLinkStatusByCompanyId[Number(companyId)] === 'linked'
      ? 'company-link-badge--linked'
      : 'company-link-badge--unlinked';
  }

  private isPermissionApproved(permission: any): boolean {
    return Number(permission?.permission_status) === this.agreedPermissionStatus;
  }

  loadCompanyLinkStatuses(): void {
    if (!this.isMerchantUser() || !this.merchantId) {
      this.companyLinkStatusByCompanyId = {};
      this.approvedCompanyIds.clear();
      return;
    }

    this.service.getAllPermissionsByMerchantIdAll(this.merchantId).subscribe({
      next: (permissions) => {
        this.approvedCompanyIds.clear();
        (permissions ?? []).forEach((permission: any) => {
          if (!this.isPermissionApproved(permission)) {
            return;
          }
          const companyId = Number(permission?.company_id ?? permission?.company?.company_id);
          if (companyId) {
            this.approvedCompanyIds.add(companyId);
          }
        });

        const companyIds = [...this.approvedCompanyIds];
        if (!companyIds.length) {
          this.companyLinkStatusByCompanyId = {};
          return;
        }

        forkJoin(
          companyIds.map((companyId) =>
            this.service.getCompanyLinksByMerchantCompany(companyId).pipe(
              map((res) => ({
                companyId,
                links: Array.isArray(res?.data) ? res.data : [],
              })),
              catchError(() => of({ companyId, links: [] }))
            )
          )
        ).subscribe({
          next: (results) => {
            const nextMap: Record<number, 'linked' | 'not_linked'> = {};
            results.forEach(({ companyId, links }) => {
              const hasActiveLink = links.some((link: any) => link?.status === 'active');
              nextMap[companyId] = hasActiveLink ? 'linked' : 'not_linked';
            });
            this.companyLinkStatusByCompanyId = nextMap;
          },
        });
      },
      error: () => {
        this.companyLinkStatusByCompanyId = {};
        this.approvedCompanyIds.clear();
      },
    });
  }

  getAllCompaniesInfo(limit?: number, offset?: number  ,keyword?: any) {
    limit = limit || this.limit;
    offset = offset || (this.currentPage - 1) * this.limit;
    this.spinner.show();
    this.service.getAllCompaniesInfo(limit, offset, keyword, undefined, this.getRecordTypeForList()).subscribe({
      next: res => {
        this.companyData = res.data;
        this.total = res.total;
        this.loadCompanyLinkStatuses();
        this.spinner.hide();
      },
      error: () => {
        this.spinner.hide();
      }
    });
  };

  exportAllToExcel(): void {
    this.spinner.show();

    this.service.getAllCompaniesExcel().subscribe({
        next: (res: Blob) => {
            // إنشاء ملف Excel من الـ Blob وتنزيله
            const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const filename = 'Companies.xlsx';
            saveAs(blob, filename);

            this.spinner.hide();
        },
        error: (err) => {
            console.error('Error fetching data:', err);
            this.spinner.hide();
        }
    });
}


  

  getAllActiveAccountingOffices( ) {
   
    this.spinner.show();
    this.service.getAllActiveAccountingOfficesAll().subscribe({
      next: offices => {
        this.activeAccountantOfficeData = offices;
        this.spinner.hide(); 
      },
      error: () => {
        this.spinner.hide();
      }
    });
  }

  getAllActiveCompanyTypes() {
    this.spinner.show();
    this.service.getAllActiveCompanyTypes().subscribe({
      next: res => {
        this.companyTypeData = res;
        this.spinner.hide();
      },
      error: () => {
        this.spinner.hide();
      }
    });
  }

  onPageChange(page: number) {
    this.currentPage = page;
    const offset = (page - 1) * this.limit;
    this.getAllCompaniesInfo(this.limit, offset, this.term);
  }
  
  onLimitChange() {
    this.limit = this.customLimit;
    this.offset = (this.currentPage - 1) * this.limit;
    this.getAllCompaniesInfo(this.limit, this.offset, this.term);
  }

  getAllMerchantInfo() {
    this.spinner.show();
    this.service.getAllMerchantInfo().subscribe({
      next: res => {
        this.merchantInfoData = res;
         
        this.spinner.hide();
      },
      error: error => {
        this.spinner.hide();
      }
    });
  };

  filterMerchant(event:any)
{
  let x = event;
 };

  filter(event:any)
{
  let x = event.target.value;
 };

  openXl(content:any) {
    this.translationPickerOpen = false;
    this.modalService.open(content, { size: 'xl', centered: true, scrollable: true });
  };

  toggleTranslationPicker(): void {
    this.translationPickerOpen = !this.translationPickerOpen;
  }

  closeTranslationPicker(): void {
    this.translationPickerOpen = false;
  }

  addTranslationLang(code: 'ar' | 'en'): void {
    if (code === 'ar') this.translationAddon.ar = true;
    else this.translationAddon.en = true;
    this.translationPickerOpen = false;
  }

  removeTranslationLang(code: 'ar' | 'en'): void {
    if (code === 'ar') {
      this.translationAddon.ar = false;
      this.addCompany.patchValue({
        company_name_ar: '',
        company_address_city_ar: '',
        company_address_str_ar: '',
      });
      this.addCompanyByAdmin.patchValue({
        company_name_ar: '',
        company_address_city_ar: '',
        company_address_str_ar: '',
      });
    } else {
      this.translationAddon.en = false;
      this.addCompany.patchValue({
        company_name_en: '',
        company_address_city_en: '',
        company_address_str_en: '',
      });
      this.addCompanyByAdmin.patchValue({
        company_name_en: '',
        company_address_city_en: '',
        company_address_str_en: '',
      });
    }
  }

  get showAddTranslationButton(): boolean {
    return !this.translationAddon.ar || !this.translationAddon.en;
  }

  onPendingLogoChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    input.value = '';
    if (!file || !file.type.startsWith('image/')) return;
    if (this.logoPreviewUrl) URL.revokeObjectURL(this.logoPreviewUrl);
    this.pendingLogoFile = file;
    this.logoPreviewUrl = URL.createObjectURL(file);
  }

  onPendingSealChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    input.value = '';
    if (!file || !file.type.startsWith('image/')) return;
    if (this.sealPreviewUrl) URL.revokeObjectURL(this.sealPreviewUrl);
    this.pendingSealFile = file;
    this.sealPreviewUrl = URL.createObjectURL(file);
  }

  clearPendingLogo(): void {
    this.pendingLogoFile = null;
    if (this.logoPreviewUrl) {
      URL.revokeObjectURL(this.logoPreviewUrl);
      this.logoPreviewUrl = null;
    }
  }

  clearPendingSeal(): void {
    this.pendingSealFile = null;
    if (this.sealPreviewUrl) {
      URL.revokeObjectURL(this.sealPreviewUrl);
      this.sealPreviewUrl = null;
    }
  }

  private runBrandingUploadsAfterCreate(companyId: number, onComplete: () => void): void {
    this.spinner.show();
    const finish = () => {
      this.spinner.hide();
      onComplete();
    };
    const doSeal = () => {
      if (!this.pendingSealFile) {
        this.clearPendingSeal();
        finish();
        return;
      }
      const fd = new FormData();
      fd.append('file', this.pendingSealFile, this.pendingSealFile.name);
      this.service
        .uploadCompanySeal(companyId, fd)
        .pipe(catchError(() => of(null)))
        .subscribe(() => {
          this.clearPendingSeal();
          finish();
        });
    };
    if (this.pendingLogoFile) {
      const fd = new FormData();
      fd.append('file', this.pendingLogoFile, this.pendingLogoFile.name);
      this.service
        .uploadCompanyImage(companyId, fd)
        .pipe(catchError(() => of(null)))
        .subscribe(() => {
          this.clearPendingLogo();
          doSeal();
        });
      return;
    }
    doSeal();
  }

  openXl3(content3:any) {
    this.modalService.open(content3, { size: 'md'  });
  };

  openMoreInfo(item: any, content: any) {
    const requestId = ++this.moreInfoRequest;
    this.moreInfoCompanyName = this.getCompanyDisplayName(item);
    this.moreInfoData = null;
    this.moreInfoLoading = true;
    this.moreInfoLoadFailed = false;
    this.modalService.open(content, {
      size: 'md',
      centered: true,
      scrollable: true,
    });
    this.service.getActivityInCompany(item.company_id).subscribe({
      next: (res) => {
        if (requestId !== this.moreInfoRequest) return;
        this.moreInfoData = res;
        this.moreInfoLoading = false;
      },
      error: () => {
        if (requestId !== this.moreInfoRequest) return;
        this.moreInfoLoading = false;
        this.moreInfoLoadFailed = true;
      },
    });
  }

  displayValue(value: unknown): string {
    if (value == null) return '—';
    const text = String(value).trim();
    return text ? text : '—';
  }

  moreInfoCompanyFieldName(): string {
    const info = this.moreInfoData?.companyInfo;
    if (!info) return '';
    if (this.curentLang === 'en') return info.company_name_en;
    if (this.curentLang === 'ar') return info.company_name_ar;
    return info.company_name_he;
  }

  moreInfoMerchantName(): string {
    const merchant = this.moreInfoData?.companyInfo?.merchant;
    if (!merchant) return '';
    if (this.curentLang === 'en') return merchant.merchant_name_en;
    if (this.curentLang === 'ar') return merchant.merchant_name_ar;
    return merchant.merchant_name_he;
  }

  moreInfoMerchantPhone(): string {
    return this.moreInfoData?.companyInfo?.merchant?.users?.[0]?.phone_number ?? '';
  }

  openXl5(content5:any, preselectedCompanyId?: number) {
    this.resetReportsForm();
    if (preselectedCompanyId) {
      this.CompanyId = preselectedCompanyId;
      this.reportsForm.patchValue({ companyId: preselectedCompanyId });
    }
    this.loadAllCompaniesForReport();
    this.modalService.open(content5, { size: 'lg'  });
  };

  loadAllCompaniesForReport() {
    this.service.getAllCompaniesInfo(1000, 0, undefined, true, 'merchant').subscribe({
      next: res => {
        this.allCompaniesForReport = res?.data ?? [];
      },
      error: () => {}
    });
  }

  onReportCompanyChange(item: any) {
    if (!item) {
      this.CompanyId = null;
      this.reportsForm.patchValue({ companyId: null });
      return;
    }
    const id = item?.company_id ?? item;
    this.CompanyId = id;
    this.reportsForm.patchValue({ companyId: id });
  }

  resetReportsForm() {
    // Reset to current month
    const currentDate = new Date();
    const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const endDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    
    this.fromDate = this.formatDate(startDate);
    this.toDate = this.formatDate(endDate);
    this.selectedPeriod = 1; // Current month
    
    this.reportsForm.patchValue({
      startDate: startDate,
      endDate: endDate,
      companyId: this.CompanyId
    });
  }

  openXl2(contentAdmin:any) {
    this.translationPickerOpen = false;
    this.modalService.open(contentAdmin, { size: 'xl', centered: true, scrollable: true });
  };

  addedData() {
    // Eligibility check for merchants only
    const ut = Number(this.user_type);
    if (ut === 100 || ut === 101) {
      this.invoiceSubscriptionsV2.canAddCompany().subscribe({
        next: (eligibility) => {
          if (!eligibility.allowed) {
            Swal.fire({
              icon: 'warning',
              title: this.curentLang === 'ar' ? 'لا يمكن إضافة مصلحة تجارية' : (this.curentLang === 'he' ? 'לא ניתן להוסיף חברה' : 'Cannot Add Company'),
              html: this.curentLang === 'ar'
                ? `وصلت للحد الأقصى للمصالح تجارية في اشتراكك الحالي (<b>${eligibility.current_count}/${eligibility.limit}</b>).<br>يرجى شراء إضافة مصالح تجارية أو الترقية.`
                : this.curentLang === 'he'
                  ? `הגעת למגבלת החברות במנוי הנוכחי שלך (<b>${eligibility.current_count}/${eligibility.limit}</b>).<br>אנא רכוש הרחבת חברות או שדרג.`
                  : `You have reached the company limit of your current subscription (<b>${eligibility.current_count}/${eligibility.limit}</b>).<br>Please purchase a company extension or upgrade.`,
              confirmButtonText: this.curentLang === 'ar' ? 'إدارة الاشتراك' : (this.curentLang === 'he' ? 'ניהול מנוי' : 'Manage Subscription'),
              showCancelButton: true,
              cancelButtonText: this.curentLang === 'ar' ? 'إلغاء' : (this.curentLang === 'he' ? 'ביטול' : 'Cancel'),
              confirmButtonColor: '#E62E2D',
            }).then((result) => {
              if (result.isConfirmed) {
                this.router.navigate(['/dashboard/invoice-subscriptions']);
              }
            });
            return;
          }
          this.doAddCompany();
        },
        error: () => {
          // If check fails, proceed anyway — server will enforce limits
          this.doAddCompany();
        },
      });
      return;
    }

    this.doAddCompany();
  }

  /** Fixed invoice footer notes — max 200 chars each (matches validators). */
  private invoiceNotesOverLimit(form: FormGroup): boolean {
    const ln = form.get('left_note');
    const rn = form.get('right_note');
    return !!(ln?.hasError('maxlength') || rn?.hasError('maxlength'));
  }

  private showInvoiceNotesLengthWarning(): void {
    Swal.fire({
      icon: 'warning',
      title:
        this.curentLang === 'ar'
          ? 'طول الملاحظات'
          : this.curentLang === 'en'
            ? 'Notes too long'
            : 'הערות ארוכות מדי',
      html:
        '<p style="margin:0;text-align:' +
        (this.curentLang === 'ar' ? 'right' : 'left') +
        '">' +
        (this.curentLang === 'ar'
          ? 'يجب ألا تتجاوز ملاحظات الفاتورة (يمين أو يسار) 200 حرفاً لكل منها.'
          : this.curentLang === 'en'
            ? 'Right and left invoice notes must be at most 200 characters each.'
            : 'הערות החשבונית (ימין ושמאל) חייבות להיות עד 200 תווים כל אחת.') +
        '</p>',
    });
  }

  private doAddCompany(): void {
    const raw = this.addCompany.value;
    if (this.invoiceNotesOverLimit(this.addCompany)) {
      this.showInvoiceNotesLengthWarning();
      this.addCompany.markAllAsTouched();
      this.addvalidateCompanyMerchant = !this.addvalidateCompanyMerchant;
      return;
    }
    const company_name_he = (raw.company_name_he ?? '').toString().trim();
    const company_address_str = (raw.company_address_str ?? '').toString().trim();
    const company_address_city = (raw.company_address_city ?? '').toString().trim();
    const typeId = raw.company_type_id;

    const missing: string[] = [];
    if (!company_name_he) {
      missing.push(this.curentLang === 'ar' ? 'اسم المصلحة التجارية (عبري)' : (this.curentLang === 'en' ? 'Company name (Hebrew)' : 'שם החברה (עברית)'));
    }
    if (typeId === '' || typeId === null || typeId === undefined) {
      missing.push(this.curentLang === 'ar' ? 'نوع المصلحة التجارية' : (this.curentLang === 'en' ? 'Company type' : 'סוג חברה'));
    }
    if (!company_address_city) {
      missing.push(this.curentLang === 'ar' ? 'المدينة (عبري)' : (this.curentLang === 'en' ? 'City (Hebrew)' : 'עיר (עברית)'));
    }
    if (!company_address_str) {
      missing.push(this.curentLang === 'ar' ? 'اسم الشارع (عبري)' : (this.curentLang === 'en' ? 'Street (Hebrew)' : 'שם רחוב (עברית)'));
    }

    if (missing.length > 0) {
      const title =
        this.curentLang === 'ar'
          ? 'يرجى تعبئة الحقول التالية:'
          : this.curentLang === 'en'
            ? 'Please complete:'
            : 'נא למלא:';
      Swal.fire({
        icon: 'warning',
        title,
        html: '<ul style="text-align:' + (this.curentLang === 'ar' ? 'right' : 'left') + ';margin:0">' +
          missing.map((m) => '<li>' + m + '</li>').join('') + '</ul>',
      });
      this.addCompany.patchValue({
        company_name_he,
        company_address_str,
        company_address_city,
      });
      this.addCompany.markAllAsTouched();
      this.addvalidateCompanyMerchant = !this.addvalidateCompanyMerchant;
      return;
    }

    let model = {
      company_name_ar: this.addCompany.value.company_name_ar,
      company_name_en: this.addCompany.value.company_name_en,
      company_name_he: this.addCompany.value.company_name_he,
      company_phone: this.addCompany.value.company_phone,
      company_address_str: this.addCompany.value.company_address_str,
      company_address_str_ar: this.addCompany.value.company_address_str_ar,
      company_address_str_en: this.addCompany.value.company_address_str_en,
      company_Building_number: this.addCompany.value.company_Building_number,
      company_address_city: this.addCompany.value.company_address_city,
      company_address_city_ar: this.addCompany.value.company_address_city_ar,
      company_address_city_en: this.addCompany.value.company_address_city_en,
      company_address_zip_code: this.addCompany.value.company_address_zip_code,
      left_note: this.addCompany.value.left_note,
      right_note: this.addCompany.value.right_note,
      tax_register: this.addCompany.value.tax_register,
      commercial_register: this.addCompany.value.commercial_register,
      vat_list_id: Number(this.addCompany.value.vat_list_id),
      company_type_id: Number(this.addCompany.value.company_type_id),
      merchant_id: Number(this.merchantId),
      created_by: Number(this.userRegistId),
    };
  
    this.spinner.show();
    this.service.Post(AddCompanyEndPoient.POST, model).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status === 200) {
          Swal.fire({
            icon: 'success',
            title: this.curentLang === 'ar' ? res.messageAr : (this.curentLang === 'en' ? res.messageEn : res.messageHe)
          });
          const companyId = res?.data?.company_id;
          const wrapUp = () => {
            this.modalService.dismissAll();
            this.getAllCompaniesInfo();
            this.getAllMerchantInfo();
            this.resetForm();
          };
          if (companyId && (this.pendingLogoFile || this.pendingSealFile)) {
            this.runBrandingUploadsAfterCreate(companyId, wrapUp);
          } else {
            this.clearPendingLogo();
            this.clearPendingSeal();
            wrapUp();
          }
        } else {
          this.handleErrorResponse(res, { suppressDuplicateRegister: true });
        }
      },
      (err) => {
        this.spinner.hide();
        this.handleErrorResponse(err, { suppressDuplicateRegister: true });
      }
    );
  }

  resetForm() {
    this.translationAddon = { ar: false, en: false };
    this.translationPickerOpen = false;
    this.clearPendingLogo();
    this.clearPendingSeal();
    this.addCompany.reset({
      company_name_ar: '',
      company_name_en: '',
      company_name_he: '',
      company_phone: '',
      company_address_str: '',
      company_address_str_ar: '',
      company_address_str_en: '',
      company_Building_number: '',
      company_address_city: '',
      company_address_city_ar: '',
      company_address_city_en: '',
      company_address_zip_code: '',
      left_note: '',
      right_note: '',
      tax_register: '',
      commercial_register: '',
      vat_list_id: null,
      company_type_id: null,
    });
  }

  resetFormAdmin() {
    this.translationAddon = { ar: false, en: false };
    this.translationPickerOpen = false;
    this.clearPendingLogo();
    this.clearPendingSeal();
    this.addCompanyByAdmin.reset({
      company_name_ar: '',
      company_name_en: '',
      company_name_he: '',
      company_phone: '',
      company_address_str: '',
      company_address_str_ar: '',
      company_address_str_en: '',
      company_Building_number: '',
      company_address_city: '',
      company_address_city_ar: '',
      company_address_city_en: '',
      company_address_zip_code: '',
      left_note: '',
      right_note: '',
      tax_register: '',
      commercial_register: '',
      merchant_id: null,
      vat_list_id: null,
      company_type_id: null,
    });
  }

  private isDuplicateRegisterError(response: any): boolean {
    const body = response?.error ?? response;
    const messages = [
      body?.messageAr,
      body?.messageEn,
      body?.messageHe,
      body?.message,
      ...(Array.isArray(body?.message) ? body.message : []),
    ]
      .filter((msg) => msg != null && String(msg).trim() !== '')
      .map((msg) => String(msg).toLowerCase());

    const patterns = [
      'مسجل مسبق',
      'رقم ضريبي',
      'رقم السجل التجاري',
      'already registered',
      'duplicate',
      'tax_register',
      'commercial_register',
      'tax register',
      'commercial register',
    ];

    return messages.some((msg) => patterns.some((pattern) => msg.includes(pattern)));
  }

  handleErrorResponse(response: any, options?: { suppressDuplicateRegister?: boolean }) {
    const body = response?.error ?? response;
    if (options?.suppressDuplicateRegister && this.isDuplicateRegisterError(body)) {
      return;
    }

    let errorMessage;
    switch (body?.status) {
      case 400:
      case 403:
      case 406:
        errorMessage = this.curentLang === 'ar' ? body.messageAr : (this.curentLang === 'en' ? body.messageEn : body.messageHe);
        break;
      default:
        errorMessage = this.curentLang === 'ar' ? 'حدث خطأ غير معروف' : (this.curentLang === 'en' ? 'An unknown error occurred' : 'אירעה שגיאה לא ידועה');
    }
    Swal.fire({
      icon: 'error',
      title: errorMessage
    });
  }

  handleErrorResponseA(response: any) {
    let errorMessage;
    switch (response.status) {
      case 400:
      case 403:
      case 406:
        errorMessage = this.curentLang === 'ar' ? response.messageAr : (this.curentLang === 'en' ? response.messageEn : response.messageHe);
        break;
      default:
        errorMessage = this.curentLang === 'ar' ? 'حدث خطأ غير معروف' : (this.curentLang === 'en' ? 'An unknown error occurred' : 'אירעה שגיאה לא ידועה');
    }
    Swal.fire({
      icon: 'error',
      title: errorMessage
    });
  }
  addedDataByAadmin() {

    const raw = this.addCompanyByAdmin.value;
    if (this.invoiceNotesOverLimit(this.addCompanyByAdmin)) {
      this.showInvoiceNotesLengthWarning();
      this.addCompanyByAdmin.markAllAsTouched();
      this.validate = !this.validate;
      return;
    }
    const company_name_he = (raw.company_name_he ?? '').toString().trim();
    const company_address_str = (raw.company_address_str ?? '').toString().trim();
    const company_address_city = (raw.company_address_city ?? '').toString().trim();
    const typeId = raw.company_type_id;
    const merchantId = raw.merchant_id;

    const missing: string[] = [];
    if (!company_name_he) {
      missing.push(this.curentLang === 'ar' ? 'اسم المصلحة التجارية (عبري)' : (this.curentLang === 'en' ? 'Company name (Hebrew)' : 'שם החברה (עברית)'));
    }
    if (typeId === '' || typeId === null || typeId === undefined) {
      missing.push(this.curentLang === 'ar' ? 'نوع المصلحة التجارية' : (this.curentLang === 'en' ? 'Company type' : 'סוג חברה'));
    }
    if (merchantId === '' || merchantId === null || merchantId === undefined) {
      missing.push(this.curentLang === 'ar' ? 'التاجر' : (this.curentLang === 'en' ? 'Merchant' : 'סוחר'));
    }
    if (!company_address_city) {
      missing.push(this.curentLang === 'ar' ? 'المدينة (عبري)' : (this.curentLang === 'en' ? 'City (Hebrew)' : 'עיר (עברית)'));
    }
    if (!company_address_str) {
      missing.push(this.curentLang === 'ar' ? 'اسم الشارع (عبري)' : (this.curentLang === 'en' ? 'Street (Hebrew)' : 'שם רחוב (עברית)'));
    }

    if (missing.length > 0) {
      const title =
        this.curentLang === 'ar'
          ? 'يرجى تعبئة الحقول التالية:'
          : this.curentLang === 'en'
            ? 'Please complete:'
            : 'נא למלא:';
      Swal.fire({
        icon: 'warning',
        title,
        html: '<ul style="text-align:' + (this.curentLang === 'ar' ? 'right' : 'left') + ';margin:0">' +
          missing.map((m) => '<li>' + m + '</li>').join('') + '</ul>',
      });
      this.addCompanyByAdmin.patchValue({
        company_name_he,
        company_address_str,
        company_address_city,
      });
      this.addCompanyByAdmin.markAllAsTouched();
      this.validate = !this.validate;
      return;
    }

    let model = {
        company_name_ar: this.addCompanyByAdmin.value.company_name_ar,
        company_name_en: this.addCompanyByAdmin.value.company_name_en,
        company_name_he: this.addCompanyByAdmin.value.company_name_he,
        company_phone: this.addCompanyByAdmin.value.company_phone,
        company_address_str: this.addCompanyByAdmin.value.company_address_str,
        company_address_str_ar: this.addCompanyByAdmin.value.company_address_str_ar,
        company_address_str_en: this.addCompanyByAdmin.value.company_address_str_en,
        company_Building_number: this.addCompanyByAdmin.value.company_Building_number,
        company_address_city: this.addCompanyByAdmin.value.company_address_city,
        company_address_city_ar: this.addCompanyByAdmin.value.company_address_city_ar,
        company_address_city_en: this.addCompanyByAdmin.value.company_address_city_en,
        company_address_zip_code: this.addCompanyByAdmin.value.company_address_zip_code,
        left_note: this.addCompanyByAdmin.value.left_note,
        right_note: this.addCompanyByAdmin.value.right_note,
        tax_register: this.addCompanyByAdmin.value.tax_register,
        commercial_register: this.addCompanyByAdmin.value.commercial_register,
        vat_list_id: Number(this.addCompanyByAdmin.value.vat_list_id),
        company_type_id: Number(this.addCompanyByAdmin.value.company_type_id),
        merchant_id: Number(this.addCompanyByAdmin.value.merchant_id),
        created_by: Number(this.userRegistId),
      };
    
       this.spinner.show();
      this.service.Post(AddCompanyEndPoient.POST, model).subscribe(
        (res) => {
          this.spinner.hide();
          if (res.status === 200) {
            Swal.fire({
              icon: 'success',
              title: this.curentLang === 'ar' ? res.messageAr : (this.curentLang === 'en' ? res.messageEn : res.messageHe)
            });
            const companyId = res?.data?.company_id;
            const wrapUp = () => {
              this.modalService.dismissAll();
              this.getAllCompaniesInfo();
              this.getAllMerchantInfo();
              this.resetFormAdmin();
            };
            if (companyId && (this.pendingLogoFile || this.pendingSealFile)) {
              this.runBrandingUploadsAfterCreate(companyId, wrapUp);
            } else {
              this.clearPendingLogo();
              this.clearPendingSeal();
              wrapUp();
            }
          } else {
            this.handleErrorResponse(res);
          }
        },
        (err) => {
          this.spinner.hide();
          this.handleErrorResponse(err);
        }
      );
  }
  
  getId(id:number)
{
   this.merchantId = id ;
   this.CompanyIdRow = id;
};

openArchiveConfirm(id: any, modal: any) {
  this.archiveCompanyId = id;
  this.modalService.open(modal, { centered: true });
}

openRestoreConfirm(id: any, modal: any) {
  this.restoreCompanyId = id;
  this.modalService.open(modal, { centered: true });
}

archiveCompany() {
  this.spinner.show();
  this.service.archiveCompany(this.archiveCompanyId).subscribe({
    next: (res) => {
      this.spinner.hide();
      if (res.status === 200) {
        Swal.fire({
          icon: 'success',
          title: this.curentLang === 'ar' ? res.messageAr : (this.curentLang === 'en' ? res.messageEn : res.messageHe)
        });
        this.modalService.dismissAll();
        this.getAllCompaniesInfo();
        this.getArchivedCompanies();
        // If the archived company is the one currently selected in the header, clear it from
        // localStorage immediately — this works even if the backend still returns it in the list.
        const currentDefault = localStorage.getItem('companyDefault');
        if (currentDefault && +currentDefault === +this.archiveCompanyId) {
          localStorage.removeItem('companyDefault');
          localStorage.removeItem('selectedCompanyLogo');
          localStorage.removeItem('company_name_ar');
          localStorage.removeItem('company_name_en');
          localStorage.removeItem('company_name_he');
        }
        window.dispatchEvent(new CustomEvent('companiesUpdated', { detail: { archivedId: +this.archiveCompanyId } }));
        const ut = Number(this.user_type);
        if (ut === 100 || ut === 101) {
          this.invoiceSubscriptionsV2.canAddCompany().subscribe({
            next: (r) => { this.canAddCompanyAllowed = r.allowed; },
            error: () => {}
          });
        }
      } else {
        this.handleErrorResponse(res);
      }
    },
    error: (err) => {
      this.spinner.hide();
      this.handleErrorResponse(err?.error ?? err);
    }
  });
}

restoreCompany() {
  this.spinner.show();
  this.service.restoreCompany(this.restoreCompanyId).subscribe({
    next: (res) => {
      this.spinner.hide();
      if (res.status === 200) {
        Swal.fire({
          icon: 'success',
          title: this.curentLang === 'ar' ? res.messageAr : (this.curentLang === 'en' ? res.messageEn : res.messageHe)
        });
        this.modalService.dismissAll();
        this.getAllCompaniesInfo();
        this.getArchivedCompanies();
        window.dispatchEvent(new CustomEvent('companiesUpdated', { detail: { restoredId: +this.restoreCompanyId } }));
        const ut = Number(this.user_type);
        if (ut === 100 || ut === 101) {
          this.invoiceSubscriptionsV2.canAddCompany().subscribe({
            next: (r) => { this.canAddCompanyAllowed = r.allowed; },
            error: () => {}
          });
        }
      } else {
        this.handleErrorResponse(res);
      }
    },
    error: (err) => {
      this.spinner.hide();
      this.handleErrorResponse(err?.error ?? err);
    }
  });
}

getArchivedCompanies() {
  this.spinner.show();
  this.service.getArchivedCompanies().subscribe({
    next: (res) => {
      this.archivedCompanyData = Array.isArray(res) ? res : (res?.data ?? []);
      this.archivedCount = this.archivedCompanyData.length;
      this.spinner.hide();
    },
    error: () => {
      this.spinner.hide();
    }
  });
}

toggleArchivedSection() {
  this.showArchivedSection = !this.showArchivedSection;
  if (this.showArchivedSection && this.archivedCompanyData.length === 0) {
    this.getArchivedCompanies();
  }
}

switchTab(tab: 'active' | 'archived') {
  if (tab === 'archived' && !this.shouldShowArchivedTab()) {
    return;
  }
  this.activeTab = tab;
  if (tab === 'archived') {
    this.getArchivedCompanies();
  } else {
    sessionStorage.removeItem(CompanyComponent.COMPANIES_TAB_STORAGE_KEY);
  }
  this.syncTabToUrl(tab);
}

private restoreTabOnEntry(): void {
  const tabFromUrl = this.route.snapshot.queryParamMap.get('tab');
  const storageKey = CompanyComponent.COMPANIES_TAB_STORAGE_KEY;

  if (tabFromUrl === 'archived' && this.shouldShowArchivedTab()) {
    this.applyTabFromRoute('archived');
    sessionStorage.removeItem(storageKey);
    return;
  }

  if (
    !tabFromUrl &&
    this.entryNavigationTrigger === 'popstate' &&
    sessionStorage.getItem(storageKey) === 'archived' &&
    this.shouldShowArchivedTab()
  ) {
    this.activeTab = 'archived';
    this.getArchivedCompanies();
    this.syncTabToUrl('archived');
    sessionStorage.removeItem(storageKey);
    return;
  }

  sessionStorage.removeItem(storageKey);
  this.applyTabFromRoute(tabFromUrl);
}

private applyTabFromRoute(tab: string | null): void {
  if (tab === 'archived' && this.shouldShowArchivedTab()) {
    if (this.activeTab !== 'archived') {
      this.activeTab = 'archived';
      this.getArchivedCompanies();
    }
    return;
  }
  if (this.activeTab !== 'active') {
    this.activeTab = 'active';
  }
}

private syncTabToUrl(tab: 'active' | 'archived'): void {
  const desired = tab === 'archived' ? 'archived' : null;
  const current = this.route.snapshot.queryParamMap.get('tab');
  if (desired === current || (desired === null && current !== 'archived')) {
    return;
  }
  this.router.navigate(['/dashboard/companies'], {
    queryParams: { tab: desired },
    replaceUrl: false,
  });
}

refreshCompanies() {
  if (this.activeTab === 'archived') {
    this.getArchivedCompanies();
  } else {
    this.getAllCompaniesInfo();
  }
}

openVerticallyCentered(dataDeleted:any) {
  this.modalService.open(dataDeleted, { centered: true });
};

deleteCompanyByCompanyId() {
  this.spinner.show();
  this.service.deleteCompanyByCompanyId(this.CompanyIdRow).subscribe({
    next: (res) => {
      if (res.status == 400) {
        Swal.fire({
          icon: 'error',
          title: this.curentLang === 'ar' ? res.messageAr : (this.curentLang === 'en' ? res.messageEn : res.messageHe)
        });
        this.spinner.hide();
        return;
      } else {
        Swal.fire({
          icon: 'success',
          title: this.curentLang === 'ar' ? res.messageAr : (this.curentLang === 'en' ? res.messageEn : res.messageHe)
        });
        this.getAllCompaniesInfo();
        this.getAllMerchantInfo();
        // this.getAllCompaniesInfoByMerchantId();
        this.getAllActiveAccountingOffices();
        this.modalService.dismissAll();
        this.spinner.hide();
      }
    },
    error: (err) => {
      Swal.fire(err.messageAr);
      this.spinner.hide(); 
    }
  });
};


  ngOnInit() {
    this.restoreTabOnEntry();

    this.route.queryParamMap.pipe(skip(1)).subscribe(params => {
      this.applyTabFromRoute(params.get('tab'));
    });

    this.getAllCompaniesInfo();
    this.getAllMerchantInfo();
    this.getArchivedCompanies();
    const ut = Number(this.user_type);
    if (ut === 100 || ut === 101) {
      this.invoiceSubscriptionsV2.canAddCompany().subscribe({
        next: (res) => { this.canAddCompanyAllowed = res.allowed; },
        error: () => { this.canAddCompanyAllowed = true; },
      });
    }
    // this.getAllCompaniesInfoByMerchantId();
    this.getAllActiveAccountingOffices();
    this.getAllActiveCompanyTypes();
  this.layoutVersion = localStorage.getItem("layout_version");
   if (this.layoutVersion == null || this.layoutVersion == undefined) {
     localStorage.setItem("layout_version", "light-only");
     this.layoutVersion= "light-only"; 
   } else {
     this.layoutVersion = localStorage.getItem("layout_version"); 
     if (this.layoutVersion === "dark-only") {
       document.body.classList.add("dark-only");
     } else {
       document.body.classList.add("light-only");

     }
   }
   this.userRegistId = JSON.parse(localStorage.getItem('user_id'));
   this.merchantId = JSON.parse(localStorage.getItem('merchant_id'));
   this.user_type = JSON.parse(localStorage.getItem('user_type'));
   this.reportsForm = this.fb.group({
    companyId: [null, Validators.required],
    startDate: ['', Validators.required],
    endDate: ['', Validators.required],
    document_type: [1],
    lang: getDefaultReportLanguage()
  });

  // Initialize with current month dates
  const currentDate = new Date();
  const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  const endDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

  this.fromDate = this.formatDate(startDate);
  this.toDate = this.formatDate(endDate);

  this.reportsForm.patchValue({
    startDate: startDate,
    endDate: endDate
  });
  };



  filterMonth(event: any) {
    const selectedValue = parseInt(event.target.value, 10);
    const currentDate = new Date();
  
    let fromDate: Date;
    let toDate: Date;
  
    switch (selectedValue) {
      case 1: // Current month
        fromDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        toDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
        break;
      case 2: // Last month
        fromDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
        toDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
        break;
      case 3: // Start of the year to the end of the current month
        fromDate = new Date(currentDate.getFullYear(), 0, 1);
        toDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
        break;
      case 4: // Last year
        fromDate = new Date(currentDate.getFullYear() - 1, 0, 1);
        toDate = new Date(currentDate.getFullYear() - 1, 11, 31);
        break;
      case 5: // Last two full months (excluding the current month)
        fromDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 2, 1);
        toDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
        break;
      default:
        return;
    }
  
    this.fromDate = this.formatDate(fromDate);
    this.toDate = this.formatDate(toDate);
    this.selectedPeriod = selectedValue;
  
    // Update the correct form (reportsForm instead of documentForm)
    this.reportsForm.patchValue({
      startDate: fromDate,
      endDate: toDate
    });
}

formatDate(date: Date): string {
  if (!date) return '';
  const day = ('0' + date.getDate()).slice(-2);
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

parseDate(dateString: string): Date {
  if (!dateString) return new Date();
  const parts = dateString.split('/');
  if (parts.length === 3) {
    // Assuming DD/MM/YYYY format
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // Month is 0-indexed
    const year = parseInt(parts[2], 10);
    return new Date(year, month, day);
  }
  return new Date(dateString);
}
onFromDateChange(event: Date): void {
  if (event) {
    this.fromDate = this.formatDate(event);
    this.reportsForm.patchValue({
      startDate: event
    });
    // Set to custom range when manually changing dates
    this.selectedPeriod = 0;
    this.validateDateRange();
  }
}

onToDateChange(event: Date): void {
  if (event) {
    this.toDate = this.formatDate(event);
    this.reportsForm.patchValue({
      endDate: event
    });
    // Set to custom range when manually changing dates
    this.selectedPeriod = 0;
    this.validateDateRange();
  }
}

validateDateRange(): void {
  if (this.fromDate && this.toDate) {
    const fromDateObj = this.parseDate(this.fromDate);
    const toDateObj = this.parseDate(this.toDate);
    
    if (fromDateObj > toDateObj) {
      // Swap dates if from date is after to date
      const temp = this.fromDate;
      this.fromDate = this.toDate;
      this.toDate = temp;
      
      this.reportsForm.patchValue({
        startDate: this.parseDate(this.fromDate),
        endDate: this.parseDate(this.toDate)
      });
    }
  }
}

confirmAction() {
  // Validate form
  if (this.reportsForm.invalid) {
    this.reportsForm.markAllAsTouched();
    Swal.fire({
      icon: 'warning',
      title: this.curentLang === 'ar' ? 'يرجى ملء جميع الحقول المطلوبة' : 
             (this.curentLang === 'en' ? 'Please fill all required fields' : 
             'אנא מלא את כל השדות הנדרשים')
    });
    return;
  }

  // Validate dates
  if (!this.fromDate || !this.toDate) {
    Swal.fire({
      icon: 'warning',
      title: this.curentLang === 'ar' ? 'يرجى اختيار تاريخ البداية والنهاية' : 
             (this.curentLang === 'en' ? 'Please select start and end dates' : 
             'אנא בחר תאריכי התחלה וסיום')
    });
    return;
  }

  // Validate date range
  const fromDateObj = this.parseDate(this.fromDate);
  const toDateObj = this.parseDate(this.toDate);
  
  if (fromDateObj > toDateObj) {
    Swal.fire({
      icon: 'warning',
      title: this.curentLang === 'ar' ? 'تاريخ البداية يجب أن يكون قبل تاريخ النهاية' : 
             (this.curentLang === 'en' ? 'Start date must be before end date' : 
             'תאריך ההתחלה חייב להיות לפני תאריך הסיום')
    });
    return;
  }

  // Validate company selection
  if (!this.CompanyId) {
    Swal.fire({
      icon: 'warning',
      title: this.curentLang === 'ar' ? 'يرجى اختيار المصلحة التجارية' : 
             (this.curentLang === 'en' ? 'Please select a company' : 
             'אנא בחר חברה')
    });
    return;
  }

  this.getReportFilters(this.CompanyId, this.fromDate, this.toDate, getDefaultReportLanguage());
}




getReportFilters(CompanyId?:any ,  fromDate?: string, toDate?: string, lang ?: any, ) {
  
    this.spinner.show();

  this.service.getFinanicalReport( CompanyId, fromDate, toDate, lang).subscribe({
    next: (pdfBlob) => {
      // إنشاء كائن Blob لملف PDF
      const blob = new Blob([pdfBlob], { type: 'application/pdf' });
      const downloadUrl = window.URL.createObjectURL(blob);

      // إنشاء عنصر <a> لتفعيل التحميل
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = `Income_Report_${CompanyId}_${fromDate}_${toDate}.pdf`;
      document.body.appendChild(a);
      a.click();

      // تنظيف الرابط والذاكرة
      document.body.removeChild(a);
      window.URL.revokeObjectURL(downloadUrl);
      this.spinner.hide();
    },
    error: () => {
      this.spinner.hide();
    }
  });
}
}
